// The University of Vermont's undergraduate majors. Read on 2026-10-01 from
// the official 2026-27 Undergraduate Catalogue's Majors and Co-Majors page
// (catalogue.uvm.edu/undergraduate/majors/), an A to Z list in which each
// major links into the college or school that offers it; that link is the
// grouping used here (the list itself marks the majors two colleges share,
// e.g. Biochemistry B.S. in Agriculture and Life Sciences and in Arts and
// Sciences). Kept: every line with a bachelor's degree, in the catalogue's
// degree abbreviations (B.S.BA., B.S.CE., B.S.Ed., ...); a major offered as
// both a B.A. and a B.S. in one college is one line with both degrees. Left
// out: the twelve Co-Majors (taken only alongside a primary major), minors,
// certificates and graduate programs. The catalogue prints "Russian B.A";
// the period is added here.
const majors = {
    "slug": "university-of-vermont",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UVM's official 2026-27 Undergraduate Catalogue, grouped by the college or school that offers it, with the degree it leads to. Co-majors, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture and Life Sciences",
            "source": {
                "label": "UVM 2026-27 Undergraduate Catalogue, Majors and Co-Majors",
                "url": "https://catalogue.uvm.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Agroecology",
                    "degree": "B.S."
                },
                {
                    "name": "Animal Science",
                    "degree": "B.S."
                },
                {
                    "name": "Animal Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Science",
                    "degree": "B.S."
                },
                {
                    "name": "Community and International Development",
                    "degree": "B.S."
                },
                {
                    "name": "Community-Centered Design",
                    "degree": "B.S."
                },
                {
                    "name": "Community Entrepreneurship",
                    "degree": "B.S."
                },
                {
                    "name": "Ecological Landscape Planning and Design",
                    "degree": "B.S."
                },
                {
                    "name": "Food Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Molecular Genetics",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition and Food Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Plant Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Public Communication",
                    "degree": "B.S."
                },
                {
                    "name": "Self-Designed",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UVM 2026-27 Undergraduate Catalogue, Majors and Co-Majors",
                "url": "https://catalogue.uvm.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art: Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Science",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Chinese",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics: Quantitative",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Film and Television Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Gender, Sexuality and Women's Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "Geosciences",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Health and Society",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Individually Designed",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Plant Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychological Science",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Zoology",
                    "degree": "B.A., B.S."
                }
            ]
        },
        {
            "name": "Grossman School of Business",
            "source": {
                "label": "UVM 2026-27 Undergraduate Catalogue, Majors and Co-Majors",
                "url": "https://catalogue.uvm.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "B.S.BA."
                }
            ]
        },
        {
            "name": "College of Education and Social Services",
            "source": {
                "label": "UVM 2026-27 Undergraduate Catalogue, Majors and Co-Majors",
                "url": "https://catalogue.uvm.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Human Development and Family Science",
                    "degree": "B.S."
                },
                {
                    "name": "Individually Designed",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                },
                {
                    "name": "Teacher Education: Art Education (PreK-12)",
                    "degree": "B.S.AE."
                },
                {
                    "name": "Teacher Education: Early Childhood Education (Birth-Gr3)",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Teacher Education: Elementary Education (K-6)",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Teacher Education: Middle Level Education (5-9)",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Teacher Education: Music Education (Pre-K - 12)",
                    "degree": "B.S."
                },
                {
                    "name": "Teacher Education: Secondary Education (7 - 12)",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Teacher Education: Special Education (Birth-Age 21)",
                    "degree": "B.S.Ed."
                }
            ]
        },
        {
            "name": "College of Engineering and Mathematical Sciences",
            "source": {
                "label": "UVM 2026-27 Undergraduate Catalogue, Majors and Co-Majors",
                "url": "https://catalogue.uvm.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S.BME."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.CE."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.CS."
                },
                {
                    "name": "Computer Science and Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.EE."
                },
                {
                    "name": "Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Engineering Management",
                    "degree": "B.S.EM."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S.EV."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S.MSC."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.ME."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S.MSC."
                }
            ]
        },
        {
            "name": "College of Nursing and Health Sciences",
            "source": {
                "label": "UVM 2026-27 Undergraduate Catalogue, Majors and Co-Majors",
                "url": "https://catalogue.uvm.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Biomedical and Clinical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Radiation Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Rubenstein School of Environment and Natural Resources",
            "source": {
                "label": "UVM 2026-27 Undergraduate Catalogue, Majors and Co-Majors",
                "url": "https://catalogue.uvm.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Environmental Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Forestry",
                    "degree": "B.S."
                },
                {
                    "name": "Parks, Recreation and Tourism",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainability, Ecology and Policy",
                    "degree": "B.S."
                },
                {
                    "name": "Wildlife and Fisheries Biology",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
